/**
 * Filtro de zona / rango alineado con cocina y reglas de pseudo-zonas Delivery / TakeAway.
 * @param {unknown[]} selectedZoneFilter
 * @param {unknown[]} selectedRangeFilter
 */
export function isKitchenZoneRangeFilterActive(selectedZoneFilter, selectedRangeFilter) {
	const hasZones = Array.isArray(selectedZoneFilter) && selectedZoneFilter.length > 0;
	const hasRanges = Array.isArray(selectedRangeFilter) && selectedRangeFilter.length > 0;
	return hasZones || hasRanges;
}

/**
 * @param {object} reservation
 * @param {{ selectedZoneFilter: string[]; rangeTableNames: string[] }} opts
 */
export function reservationPassesKitchenZoneRangeFilter(reservation, { selectedZoneFilter, rangeTableNames }) {
	const zones = Array.isArray(selectedZoneFilter) ? selectedZoneFilter : [];
	const hasZone = zones.length > 0;
	const rangeSet = new Set(
		(Array.isArray(rangeTableNames) ? rangeTableNames : [])
			.map((n) => String(n).trim())
			.filter(Boolean),
	);
	const hasRange = rangeSet.size > 0;

	if (!hasZone && !hasRange) {
		return true;
	}

	const type = (reservation.type || '').toLowerCase();
	if (type === 'delivery') {
		return zones.includes('Delivery');
	}
	if (type === 'takeaway') {
		return zones.includes('TakeAway');
	}

	let matchZone = false;
	if (hasZone && reservation.roomName) {
		matchZone = zones.includes(reservation.roomName);
	}

	let matchRange = false;
	if (hasRange) {
		const candidates = new Set();
		if (reservation.table != null && reservation.table !== '') {
			candidates.add(String(reservation.table).trim());
		}
		if (Array.isArray(reservation.tables)) {
			reservation.tables.forEach((t) => {
				const n = String(t?.name ?? t).trim();
				if (n) candidates.add(n);
			});
		}
		for (const c of candidates) {
			if (rangeSet.has(c)) {
				matchRange = true;
				break;
			}
		}
	}

	return matchZone || matchRange;
}
